'use client';

import {
    useSingleTypeEditor,
    UseSingleTypeEditorType
} from "@/app/lib/hooks/use-editor/useSingleTypeEditor";
import {
    SiteCityCuratorArchaeology,
    SiteCityCuratorArchaeologyInput
} from "@/app/lib/generated/graphql-types";
import { createContext, ReactNode, useContext } from "react";
import { SiteCityCuratorArchaeologyEditable } from "@/app/features/sites/city-curator-archaeology/types/types";
import { SiteCityCuratorArchaeologySchema } from "@/app/features/sites/city-curator-archaeology/types/schema";
import { updateSiteCityCuratorArchaeology } from "@/app/features/sites/city-curator-archaeology/data-access/mutation";
import FloatingEditorMenu from "@/app/features/shared/__to_be_integrated/FloatingEditorMenu";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";
import { toggleDraftMode } from "@/app/lib/actions/editing";
import { getSiteCityCuratorArchaeology } from "@/app/features/sites/city-curator-archaeology/data-access/queries";

const SiteCityCuratorArchaeologyContext = createContext<UseSingleTypeEditorType<SiteCityCuratorArchaeology> | undefined>(undefined);

export function useSiteCityCuratorArchaeologyEditor() {
    const context = useContext(SiteCityCuratorArchaeologyContext);
    if (!context) {
        throw new Error("useSiteCityCuratorArchaeologyEditor must be used within a SiteCityCuratorArchaeologyProvider");
    }
    return context;
}

interface SiteCityCuratorArchaeologyProviderProps {
    children: ReactNode;
    isDraftModeEnabled: boolean;
}

export default function SiteCityCuratorArchaeologyProvider({ children, isDraftModeEnabled }: SiteCityCuratorArchaeologyProviderProps) {
    const editor = useSingleTypeEditor<SiteCityCuratorArchaeology, SiteCityCuratorArchaeologyEditable, SiteCityCuratorArchaeologyInput>({
        schema: SiteCityCuratorArchaeologySchema,
        loadEntity: getSiteCityCuratorArchaeology,
        update: updateSiteCityCuratorArchaeology,
    })

    if (editor.isLoading) return <LoadingSpinner />

    return (
        <SiteCityCuratorArchaeologyContext.Provider value={editor}>
            {children}
            <FloatingEditorMenu
                autosaveState={editor.autosaveState}
                isDraftModeEnabled={isDraftModeEnabled}
                toggleDraftMode={toggleDraftMode}
                hasChanges={editor.hasChanges}
                onPublish={editor.publish}
                onDiscard={editor.discardChanges}
            />
        </SiteCityCuratorArchaeologyContext.Provider>
    )
}
